import { ErrorMessage, Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react';

import MyTextInput, { MyTextInputMayusculas } from '../../app/common/form/MyTextInput';
import ValidationErrors from '../errors/ValidationErrors';
import { Button, Header, Label } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import * as Yup from 'yup';

import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import RegisterBack from "../../../src/images/register-back.png"

export default observer(function RegisterForm() {
    const { userStore } = useStore();
    const lowercaseRegex = /(?=.*[a-z])/;
    const uppercaseRegex = /(?=.*[A-Z])/;
    const numericRegex = /(?=.*[1-9])/;
    const caracterRegex = /(?=.*[@$!%*#?&%-/])/;

    const validationSchema = Yup.object({
        displayName: Yup.string().required('Obligatorio'),
        //userName: Yup.string().required('Obligatorio'),
        email: Yup.string().required('Obligatorio').email(),
        password: Yup.string()
            .min(8, "Se requieren al menos 8 caracteres, entre ellos, al menos una letra mayuscula, un número y un caracter especial")
            .matches(lowercaseRegex,
                "Debe incluir minusculas"
            )
            .matches(uppercaseRegex,
                "Debe incluir alguna mayuscula"
            )
            .matches(numericRegex,
                "Debe incluir algun numero"
            )
            .matches(caracterRegex,
                "Debe incluir algun caracter especial"
            )
            .required("La contraseña es obligatoria"),

        passwordConfirma: Yup.string().required("La confirmación es obligatoria")
            .oneOf([Yup.ref("password")], "Las Contraseñas no coinciden"),
    })

    return (

        <Formik
            initialValues={{ displayName: '', email: '', password: '', passwordConfirma: '', error: null }}
            onSubmit={(values, { setErrors }) => userStore.register(values).catch(error =>
                setErrors({ error }))}
            validationSchema={validationSchema}
        >
            {({ handleSubmit, isSubmitting, errors, isValid, dirty }) => (

                <>

                    <Container className='register-form-area' id='register-form-area'>
                        <h2>Registro</h2>
                        <h3>Crea una cuenta para acceder a la plataforma.</h3>
                        <div className='register-back' style={{ backgroundImage: `url(${RegisterBack})` }}></div>
                        <Row>
                            <Col>

                                <Form className='ui register-form' onSubmit={handleSubmit} autoComplete='off'>
                                    <MyTextInput name='displayName' label='Nombre completo' placeholder='Ingresa tu nombre completo' />
                                    <MyTextInput name='email' label='Correo electrónico' placeholder='tu-correo@gmail.com' />
                                    <MyTextInput name='password' label='Contraseña' placeholder='********' type='password' />
                                    <MyTextInput name='passwordConfirma' label='Confirmar contraseña' placeholder='********' type='password' />
                                    <ErrorMessage
                                        name='error' render={() =>
                                            <ValidationErrors errors={errors.error} />}
                                    />

                                    <div className='form-submit-register'>
                                        <Button disabled={!isValid || !dirty || isSubmitting} loading={isSubmitting} content='Registrarme' type='submit' />
                                    </div>

                                </Form>

                            </Col>
                        </Row>
                    </Container>

                </>

            )}

        </Formik>


    )
})